<template>
    <z-caption tag="h2" size="xl">{{ formTextLocalize.title }}</z-caption>
    <products-ipp-form></products-ipp-form>
</template>

<script setup>
import { formTextLocalize } from './composable/useLocalize';
import { ProductsIppForm } from './components/ProductsIppForm';

</script>

<style lang="scss">

</style>